import React from "react";
import { ChatFrame } from "./ChatFrame";
import { ConversationList } from "./ConversationList";

export const ChatView = (props) => {
  const { selectedChat } = props;
  return (
    <div className="chat-view-wrapper">
      <ConversationList {...props} />
      {selectedChat ? <ChatFrame {...props} /> : null}
    </div>
  );
};

const DesktopView = () => {};

const MobileView = () => {};
